<template>
  <div>
    <div class="page" ref="page">
      <div class="container">
        <!--顶部固定-->
        <div class="top">
          <!--课程类型筛选-->
          <div class="select-tab-row ml-30 mr-30">
            <ul>
              <li
                class="select-tab-row-li"
                :class="{ 'tab-selected': item.value === courseFilterType }"
                v-for="(item, index) in courseFilterTypeList"
                :key="index"
                @click="changeSelected(item.value)"
              >
                <div class="dot-wrap">
                  {{ item.name }}
                  <div class="dot bc1" v-if="index === 3 && isRedTip"></div>
                </div>
              </li>
            </ul>
          </div>

          <!--排序-->
          <div
            key="sort-key-row ml-30 mr-30 s4 t3"
            v-if="courseFilterType !== 4"
          >
            <div class="sort-key-tabs">
              <div
                class="sort-key-tab sort-key-tab-active"
                :style="{ visibility: allItem.hide ? 'hidden' : 'initial' }"
              >
                <span class="sort-key-name" @click="changeSortKey(allItem, 0)">
                  {{ selectName }}
                  <van-icon name="arrow-down" />
                </span>
              </div>
              <div
                class="sort-key-tab"
                v-for="(item, index) in sortKeyList"
                :key="index"
                :class="{
                  'sort-key-tab-active': activeSortKey === index
                }"
              >
                <span class="sort-key-name" @click="changeSortKey(item, index)">
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="select-pannel"
          v-if="showSelect"
          @click.self="hideSelectPannel"
        >
          <ul id="selectPannel">
            <li
              v-for="(item, index) in selectTypeList"
              :key="index"
              class="select-key-tab"
              @click="checkSelectFun(item)"
              :class="{
                'select-key-tab-active': activeSelectKey === item.value
              }"
            >
              <span>{{ item.name }}</span
              ><van-icon
                class="my-icon"
                name="success"
                v-if="activeSelectKey === item.value"
              />
            </li>
          </ul>
        </div>
        <!--课程列表-->
        <div class="list" v-if="!isShowList">
          <van-list
            v-model="loading"
            :finished="pageEnd"
            finished-text="加载完毕"
            @load="onLoad"
          >
            <course-list-item
              class="course-item ml-30"
              v-for="(item, index) in courseList"
              :key="index"
              :data="item"
              :courseFilterType="courseFilterType"
              @goto="goto(item)"
            ></course-list-item>
          </van-list>
        </div>
        <div class="no-login-wrap" v-else>
          <div class="no-login"></div>
          <div class="font s8">暂无课程，赶紧去订购一个吧</div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { getAdvertisements } from '@/api/index'
import { getCourseSetList, RedTip } from '@/api/course'
import { Icon } from 'vant'
import CourseListItem from '@/components/Course/CourseListItem.vue'

export default {
  name: 'Course',
  components: { CourseListItem, [Icon.name]: Icon },
  data() {
    return {
      images: [],
      codes: 'course',
      activeSortKey: 0,
      viewState: '',
      middleList: [],
      activeSelectKey: 0,
      courseFilterTypeList: [
        { name: '往期', value: 6 },
        { name: '订阅', value: 5 },
        { name: '专辑', value: 3 },
        { name: '已购', value: 4 }
      ],
      selectTypeList: [
        { name: '全部', value: 0 },
        { name: '年课', value: 2 },
        { name: '月课', value: 1 }
      ],
      allItem: {
        name: '全部',
        type: 0,
        hide: false,
        showIcon: true
      },
      selectName: '全部',
      sortKeyList: [
        {
          name: '最新更新',
          type: 0
        },
        {
          name: '销量最高',
          type: 1
        }
      ],
      courseList: [],
      isRedTip: false,
      pageEnd: false,
      loading: false,
      showSelect: false,
      courseFilterType: 6 //客户端课程筛选类型
    }
  },
  created() {
    this.getAdvert()
    this.RedTipFun()
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    isLogin() {
      return !!this.userInfo
    },
    isShowList() {
      return this.courseFilterType === 4 && !this.isLogin
    }
  },
  mounted() {
    const appId = this.$route.query.appId
    const wxAppId = this.$route.query.wxAppId
    if (appId) {
      localStorage.setItem('currentAppId', appId)
      localStorage.setItem('wxAppId', wxAppId)
    }
  },
  methods: {
    async getAdvert() {
      const detail = await getAdvertisements(this.codes)
      if (detail.length > 0) {
        this.middleList = detail[0].list
      }
    },

    changeSelected(val) {
      this.courseFilterType = val
      if (this.courseFilterType !== 6) {
        this.allItem.hide = true
        this.showSelect = false
        this.activeSelectKey = 0
        this.activeSortKey = 0
        if (this.courseFilterType === 5) {
          this.sortKeyList[1].name = '订阅最多'
        } else {
          this.sortKeyList[1].name = '销量最高'
        }
        this.selectName = '全部'
      } else {
        this.allItem.hide = false
        this.activeSortKey = 0
      }
      if (this.courseFilterType == 4 && !this.isLogin) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '登录后，可查看你购买的视频',
            confirmButtonText: '去登录'
          })
          .then(() => {
            this.$router.push({
              path: '/login',
              query: {
                source: '/course'
              }
            })
          })
          .catch(() => {})
      } else {
        this.initSearch()
      }
    },
    initSearch() {
      this.viewState = ''
      this.getCourseList()
      this.$refs.page.scrollTo(0, 0)
    },
    checkSelectFun(val) {
      this.activeSelectKey = val.value
      this.initSearch()
      this.showSelect = false
      this.selectName = val.name
    },
    changeSortKey(item, index) {
      this.showSelect = item.showIcon
      this.activeSortKey = index
      this.initSearch()
    },
    async getCourseList() {
      const sortKey = this.sortKeyList[this.activeSortKey]
      let sortType =
        this.activeSelectKey !== 0
          ? this.activeSelectKey
          : this.courseFilterType

      const data = await getCourseSetList(
        {
          type: sortType,
          sortKey: sortKey.type,
          orderBy: sortKey.direction,
          direction: this.viewState ? 2 : 0
        },
        this.viewState
      )

      if (data && data.result.code === 0) {
        this.viewState = data.result.viewState
        this.pageEnd = data.detail.end
        this.courseList = data.detail.flush
          ? data.detail.list
          : this.courseList.concat(data.detail.list)
      }
    },

    async RedTipFun() {
      const data = await RedTip()
      this.isRedTip = data
    },
    async onLoad() {
      await this.getCourseList()
      // 加载状态结束
      this.loading = false
    },
    goto(item) {
      if (item.courseSetType === 5) {
        this.$router.push(
          `/course-detail/${item.setId}?goodsSetId=${item.goodsSetId}`
        )
      } else {
        this.$router.push(`/course/${item.setId}?goodsSetId=${item.goodsSetId}`)
      }
    },
    hideSelectPannel() {
      this.showSelect = false
    }
  }
}
</script>

<style lang="scss" scoped>
.no-login-wrap {
  margin-top: 142px;
  .no-login {
    width: 402px;
    height: 224px;
    background: url('./images/nologin.png') no-repeat;
    background-size: cover;
    margin: 180px auto 0;
  }
  .font {
    text-align: center;
    margin-top: 60px;
    color: #858585;
  }
}
.dot-wrap {
  position: relative;
  .dot {
    position: absolute;
    right: 18px;
    top: 14px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    transform: scale(0.5, 0.5);
  }
}
.container {
  display: flex;
  flex-direction: column;
}
.top {
  position: fixed;
  // height: 416px;
  height: 142px;
  width: 100%;
  background-color: #ffffff;
  z-index: 100;
}
.list {
  // margin-top: 438px;
  margin-top: 142px;
}
.adv {
  height: 276px;
  max-width: 750px;
}
.adv img {
  width: 690px;
  height: 216px;
  border-radius: 10px;
}
.select-tab-row {
  max-width: 750px;
  box-sizing: border-box;
}
.select-tab-row ul {
  display: flex;
  justify-content: center;
  height: 80px;
  line-height: 80px;
  background-color: #ffffff;
}
.select-tab-row-li {
  display: inline-block;
  font-size: 32px;
  color: #262626;
  flex: auto;
  text-align: center;
  cursor: pointer;
  background-color: #ffffff;
}
.tab-selected {
  display: inline-block;
  font-size: 32px;
  color: #046bcc;
  flex: auto;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-weight: bold;
  &::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 6px;
    background-color: #046bcc;
    border-radius: 5px;
  }
}
.sort-key-tabs {
  font-size: 24px;
  height: 60px;
  line-height: 60px;
  letter-spacing: 1px;
  color: #858585;
  display: flex;
  justify-content: center;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #ebebeb;
  list-style: none;
  background-color: #ffffff;
  max-width: 750px;
  box-sizing: border-box;
  .sort-key-tab {
    cursor: pointer;
    flex: 1;
    text-align: center;
    &.sort-key-tab:first-child {
      flex: 2;
      text-align: left;
      padding-left: 32px;
    }
  }
  .sort-key-tab-active {
    font-weight: bold;
    color: #046bcc;
  }

  .sort-key-name {
    display: inline-flex;
    align-items: center;
    margin-right: 15px;
    justify-content: center;
  }
}

.select-pannel {
  position: fixed;
  top: 142px;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  width: 100%;
  z-index: 1;
  height: 100%;
  .select-key-tab {
    padding: 36px 30px 32px;
    background: #fff;
    border-bottom: 1px solid #ebebeb;
  }
  .select-key-tab:last-child {
    border: none;
  }
  .select-key-tab-active {
    color: #046bcc;
  }
  .my-icon {
    float: right;
  }
}

.course-item {
  margin-top: 76px;
}
.flx {
  display: flex;
}
.flx-col {
  display: flex;
  flex-direction: column;
}
.split-line {
  height: 1px;
  background-color: #ebebeb;
}
.split-line-20 {
  height: 20px;
  background-color: #f0f0f0;
}
.mr-10 {
  margin-right: 10px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-40 {
  margin-top: 40px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-40 {
  margin-bottom: 40px;
}
.ml-14 {
  margin-left: 14px;
}
.ml-20 {
  margin-left: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.mr-30 {
  margin-right: 30px;
}
.fw-b {
  font-weight: bold;
}
.fl-l {
  float: left;
}
.fl-r {
  float: right;
}
</style>
